export const ContractAttachFileType = {
  CONTRACT: 'CONTRACT',
  ESTIMATE: 'ESTIMATE',
} as const;

export type ContractAttachFileType = keyof typeof ContractAttachFileType;
